export enum IsSentEnum {
  All = 0,
  Sent = 1,
  NotSent = 2,
  Archived = 3,
}
